const HTTP_TYPE_POST = 'post';

function _apiSend(
  url,
  postType,
  data,
  successCallback,
  failureCallback,
  alwaysCallback,
) {
  return $.ajax({
    url,
    type: postType,
    data,
    success(response, textStatus, jqXHR) {
      if (!Object.prototype.hasOwnProperty.call(response, 'success')) {
        successCallback(response);
        return false;
      }

      if (response.success) {
        successCallback(response);
      } else {
        failureCallback(jqXHR, response);
      }
      return true;
    },
    error(jqXHR) {
      failureCallback(jqXHR);
    },
  }).always(alwaysCallback);
}

const newBookNotification = {
  get(seriesId) {
    return $.ajax({
      url: `/api/new-book-notifications/series/${seriesId}/is-in-use`,
      type: 'GET',
      dataType: 'json',
    });
  },

  registerSeriesNotification(series_id) {
    return $.ajax({
      url: `/api/new-book-notifications/series/${series_id}`,
      type: 'POST',
    });
  },

  unregisterSeriesNotification(series_id) {
    return $.ajax({
      url: `/api/new-book-notifications/series/${series_id}`,
      type: 'DELETE',
    });
  },

  register(
    targetId,
    targetType,
    _token,
    successCallback,
    failureCallback,
    alwaysCallback,
  ) {
    const postData = { ids: targetId, type: targetType, _token };

    return _apiSend(
      '/notification/new-release/register-notification',
      HTTP_TYPE_POST,
      postData,
      successCallback,
      failureCallback,
      alwaysCallback,
    );
  },

  unregister(
    targetId,
    targetType,
    option,
    order,
    _token,
    successCallback,
    failureCallback,
    alwaysCallback,
  ) {
    const postData = {
      ids: targetId,
      type: targetType,
      option,
      order,
      _token,
    };

    return _apiSend(
      '/notification/new-release/unregister-notification',
      HTTP_TYPE_POST,
      postData,
      successCallback,
      failureCallback,
      alwaysCallback,
    );
  },

  changeAlarm(
    isAlarmCenter,
    isEmail,
    isPush,
    _token,
    successCallback,
    failureCallback,
    alwaysCallback,
  ) {
    const postData = {
      is_alarm_center: isAlarmCenter,
      is_email: isEmail,
      is_push: isPush,
      _token,
    };

    return _apiSend(
      '/notification/new-release/change-alarm-type',
      HTTP_TYPE_POST,
      postData,
      successCallback,
      failureCallback,
      alwaysCallback,
    );
  },

  notificationOrder(notiType, order) {
    return window.location.replace(
      `/notification/new-release/${notiType}?order=${order}`,
    );
  },

  reopenNotification(
    bookId,
    _token,
    successCallback,
    failureCallback,
    alwaysCallback,
  ) {
    const postData = { book_id: bookId, _token };

    return _apiSend(
      '/notification/new-release/register-reopen-notification',
      HTTP_TYPE_POST,
      postData,
      successCallback,
      failureCallback,
      alwaysCallback,
    );
  },
};

export default newBookNotification;



// WEBPACK FOOTER //
// ./common/new_book_notification.lib.js